const { gsap } = require("gsap/dist/gsap");
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

$(function () {
	gsap.registerPlugin(ScrollTrigger);
	if ($(window).width() > 991) {//desktop
		var movementFactor = 0.7;
	} else {
		var movementFactor = 0.3;
	}

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: ".parallax-trigger",
			start: "top 50%",
			end: "bottom top",
			scrub: true
		}
	});

	gsap.utils.toArray(".has-parallax").forEach(layer => {
		const depth = 200;
		const movement = -depth * movementFactor;
		tl.to(layer, { y: movement, ease: "none" }, 0);
	});

});
